import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import {MenuButtonBulletedList} from 'mui-tiptap';

const StyledEditorMenuButtonBulletedList = styled(MenuButtonBulletedList)`
  ${ComponentStyles}
`;

StyledEditorMenuButtonBulletedList.propTypes = {
  theme: PropTypes.object
};

export default StyledEditorMenuButtonBulletedList;
